import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormCurrencyAccountModule } from '../mat-forms/currency-account/currency-account.module';
import { SharedModule } from '../shared.module';
import { SidebarModule } from '../sidebar/sidebar.module';
import { ButtonCreateCurrencyAccountComponent } from './button-create-currency-account.component';

@NgModule({
  declarations: [ButtonCreateCurrencyAccountComponent],
  imports: [
    SharedModule,
    MatButtonModule,
    MatTooltipModule,
    SidebarModule,
    FormCurrencyAccountModule,
  ],
  exports: [ButtonCreateCurrencyAccountComponent],
})
export class ButtonCreateCurrencyAccountModule {}
